import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { NotebookPen, Download } from 'lucide-react';
import { API_BASE } from '../../config/api';
import { downloadModuleNotes } from '../../lib/studyGuide';
import InfoPanel from './InfoPanel';

const API = `${API_BASE}/api`;

export const useMyStudyNotes = (programmeId, token) => {
  const [notes, setNotes] = useState([]);
  useEffect(() => {
    if (!token) return;
    axios.get(`${API}/programmes/${programmeId}/my-study-notes`, { headers: { Authorization: `Bearer ${token}` } })
      .then((r) => setNotes(r.data.notes || []))
      .catch(() => setNotes([]));
  }, [programmeId, token]);
  return notes;
};

export default function StudyNotesCard({ programmeId, token, notes, open, onToggle }) {
  if (!notes.length) return null;
  return (
    <InfoPanel testId="learner-study-notes" title={`Study notes (${notes.length})`} icon={NotebookPen} open={open} onToggle={onToggle}>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 pt-3">
        {notes.map((n) => (
          <button key={n.module_id} type="button" onClick={() => downloadModuleNotes(programmeId, n.module_id, token).catch((e) => toast.error(e.message))}
            className="group flex items-center justify-between gap-3 p-4 rounded-xl border border-zinc-800 bg-zinc-900 hover:border-teal-500/50 text-left transition-colors"
            data-testid={`learner-study-notes-${n.module_id}`}>
            <span className="min-w-0">
              <span className="block text-sm font-medium text-white truncate">{n.title}</span>
              <span className="block text-xs text-zinc-500">{n.source === 'upload' && n.filename?.toLowerCase().endsWith('.pdf') ? 'PDF' : 'Word document'}</span>
            </span>
            <Download className="h-4 w-4 text-teal-400 shrink-0 transition-transform group-hover:translate-y-0.5" />
          </button>
        ))}
      </div>
    </InfoPanel>
  );
}
